import TextLayout from "../../components/layouts/TextLayout";
import { contentPrivacyPolicy } from "./_content";

export default function PrivacyPolicyPage() {
  return (
    <TextLayout
      title="Privacy Policy"
      lastUpdated="10 August 2025"
    >
      {contentPrivacyPolicy}
    </TextLayout>
  );
}
